import React from 'react';
import { useGlobalContext } from '../../context/global.context';

const DateTimeDisplay = ({ value, type, isDanger}) => {
  const {redirectTo} = useGlobalContext()
  let path = redirectTo? redirectTo : 'Login'
  return (
    <div className="p-d-flex p-flex-column p-ai-center p-jc-center" >
      <p>En <span style={isDanger ?  {  color: "#ff0000", fontWeight:'bold' }: {} }>{value}</span> segundos será redirigido a la pantalla de {path}.</p>
    </div>
  );
};

export default DateTimeDisplay;